/*jshint esversion: 9 */
import React, { Component } from "react";
import { connect } from "react-redux";

import * as actions from "../store/actions/index";
import Attachment from "./Attachment";
import { doLog } from "../shared/utility";

class Attachments extends Component {
  state = {
    
  };

  addInitialAttachmentItem() {
    const attachmentFields = null;
    const attachmentItem = {
      attachmentInstance: 0,
      attachmentFields: attachmentFields,
    };

    if (doLog()) console.log("[Attachments] addInitialAttachmentItem attachmentItem:", attachmentItem);
    this.props.onAddToAttachmentArray(this.props.attachmentArray, attachmentItem);
    return attachmentItem;
  }

  checkForEmptyArray() {
        const arraySize = this.props.attachmentArray.length;
        if (doLog()) console.log("[Attachments].checkForEmptyArray arraySize:" + arraySize);
        if (arraySize === 0) {
          this.addInitialAttachmentItem();
        }
  }

  componentDidMount() {
    if (doLog()) console.log("[Attachments].componentDidMount");
    this.checkForEmptyArray();
  }

  componentDidUpdate() {
    if (doLog()) console.log("[Attachments].componentDidUpdate");
    if (doLog()) console.log("[Attachments].componentDidUpdate props:", this.props);
    this.checkForEmptyArray();
  }

  render() {
    const content = [];

    const arraySize = this.props.attachmentArray.length;
    if (doLog()) console.log("[Attachments].render arraySize:" + arraySize);
    if (arraySize > 0) {
        for (let i = 0; i < arraySize; i++) {
        const item = this.props.attachmentArray[i];
        content.push(<Attachment key={item.attachmentInstance} item={item} />);
        }
    }

    if (doLog()) console.log("[Attachments].render content:", content);

return (
    <div>
        {content}
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log('[Attachments].mapStateToProps state:', state);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    configuration: state.trans.configuration,
    //
    attachmentArray: state.trans.attachmentArray,
    //
    stateList: state.trans.stateList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddToAttachmentArray: (attachmentArray, attachmentItem) =>
      dispatch(actions.addToAttachmentArray(attachmentArray, attachmentItem)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Attachments);
